export const HealthChecker = {
  async checkPrebidServer() {
    try {
      const response = await fetch("https://localhost:8443/status", { method: "GET" });
      const result = await response.json();
      
      const isHealthy = result?.status === "ok";

      return isHealthy;
    } catch (error) {
      //console.warn("[HealthChecker] Failed to check Prebid Server status. Defaulting to client-side bidding.");
      return false;
    }
  }
}; 
